import { useDispatch, useSelector } from "react-redux"
import { addToCart } from "./cartSlice"
import { useCallback, useState } from "react";

export const Add = ({rest}) =>{
    const dispatch = useDispatch();
    const hasPayment = useSelector(state => state.header.hasPayment);

    const [isClicked, setIsClicked] = useState(false);

    const addedData = (rest) => {
        const {id, modificators} = rest;

        const result = {
            id: id,
            modificators: [],
            qty: 1
        }

        for (let key in modificators) {
            if (modificators.hasOwnProperty(key)) {
                const defaultModificators = modificators[key].modificators.filter(item => item.default);
                result.modificators.push(...defaultModificators);
            }
        }

        return result;
    }

    const handleAddToCart = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(addToCart(addedData(rest)));
        setIsClicked(true);
    }, [dispatch, addedData]);

    if (!hasPayment) {
        return null;
    }

    return <button className="add" onClick={handleAddToCart} disabled={isClicked}>Додати</button>
}